import React, { ReactNode } from "react";
import PropTypes from "prop-types";
import { Paper, Typography, Grid, PaperProps } from "@material-ui/core";
import { v4 } from "uuid";

import useStyles from "./styles";
import IconButton from "../IconButton";

export default function SectionContentWrapper({
  title,
  titleLabel,
  titlePadding,
  buttons,
  rightContent,
  ...rest
}: PaperProps & {
  title?: ReactNode;
  titleLabel?: ReactNode;
  titlePadding?: string;
  buttons?: any[];
  rightContent?: JSX.Element;
}): JSX.Element {
  const { titleWrapper, titleLabelStyle, paper, content, right } = useStyles({
    titlePadding,
  });
  return (
    <Grid item container direction="column">
      <Grid container className={titleWrapper}>
        <Grid item xs={buttons ? 8 : 12} container alignItems="center">
          {typeof title === "string" ? (
            <Typography
              variant="h4"
              style={{ fontFamily: "TTtravels, sans-serif" }}
            >
              {title}
            </Typography>
          ) : (
            title
          )}
          {rightContent}
        </Grid>
        <Grid
          container
          className={right}
          item
          xs={4}
          justifyContent="flex-end"
          alignItems="flex-start"
        >
          {buttons?.map(({ icon, label, action, ...restButton }) => (
            <IconButton key={v4()} icon={icon} onClick={action} {...restButton}>
              {label}
            </IconButton>
          ))}
        </Grid>
        <Grid item xs={12}>
          {typeof title === "string" ? (
            <Typography
              variant="body1"
              component="span"
              className={titleLabelStyle}
            >
              {titleLabel}
            </Typography>
          ) : (
            titleLabel
          )}
        </Grid>
      </Grid>
      <Grid item className={content}>
        <Paper {...rest} className={paper} />
      </Grid>
    </Grid>
  );
}

SectionContentWrapper.defaultProps = {
  title: undefined,
  titleLabel: undefined,
  titlePadding: undefined,
  buttons: null,
  rightContent: undefined,
};

SectionContentWrapper.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  titleLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  titlePadding: PropTypes.string,
  buttons: PropTypes.array,
  rightContent: PropTypes.object,
};
